export default "__VITE_ASSET__C1jaT$_m__"